import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../app.config';
import { CacheService } from './cache.service';
import { HttpService } from './http.service';
import { Sagai } from '../model/sagai';
import { GOODWILL_CONSTANT } from '../utils/constant';

@Injectable({
  providedIn: 'root',
})
export class SagaiService {
  domain: string;

  constructor(
    private http: HttpClient,
    private apiconfig: AppConfig,
    private cacheService: CacheService,
    private httpservice: HttpService
  ) {
    let apipath = '';
    if (this.apiconfig.mpsaFlag === 'N') {
      apipath = location.protocol + '//' + this.apiconfig.apiUrl;
    }

    this.domain = apipath + this.apiconfig.apiPath;
  }


 getDetailsFromSAGAI(sagai: Sagai) {
  //const queryParams = this.httpservice.prepareQueryParams(sagai);
  let finalURL =  this.domain + GOODWILL_CONSTANT.ABACUS_DETAILS;
  return this.httpservice.post(finalURL,JSON.stringify(sagai));
}

 
}